import { BrutalistBadge, GlassCard } from "@/app/components/brand-scaffold";

const glassCardProps = {
  bgClass: "bg-white/75",
  hoverClass: "hover:bg-white/95",
  className: "!p-5 flex flex-col",
} as const;

export function HomepageWhatIsHotline() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20 bg-black/[0.04]">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-[#A3E635]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
            WHAT IS A HOTLINE
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-8">
          一根 Hotline 是什么？
        </h2>
        <p className="text-lg sm:text-xl font-bold text-zinc-800 mb-8 max-w-3xl">
          Hotline 是 Agent 可以调用的能力入口。它不是一条电话线，而是一份标准化的能力契约。
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hotlineContains.map((item) => (
            <GlassCard key={item.title} {...glassCardProps}>
              <h3 className="font-black text-black mb-1">{item.title}</h3>
              <p className="text-sm text-zinc-700">{item.desc}</p>
            </GlassCard>
          ))}
        </div>
        <div className="mt-8 border-l-8 border-black pl-5">
          <p className="text-base sm:text-lg font-bold text-zinc-800">
            你可以把 Hotline 暴露成 MCP Server、OpenAPI endpoint 或 Skill wrapper。这些是接入面；Hotline 是能力的产品化契约。
          </p>
        </div>
      </div>
    </section>
  );
}

const hotlineContains = [
  { title: "能力描述", desc: "这根能力能做什么" },
  { title: "输入 Schema", desc: "需要什么输入" },
  { title: "输出 Schema", desc: "会返回什么输出" },
  { title: "风险与限制", desc: "边界和注意事项" },
  { title: "提供方", desc: "由谁提供和维护" },
  { title: "版本与审计", desc: "版本号 + 调用结果如何被记录和验证" },
];
